import { STEPS } from "/cdn/shop/t/98/assets/steps.constant.js";
import { PRINTING_TYPES } from "/cdn/shop/t/98/assets/printingOptions.constant.js?cash48";

export default {
    props: [
        "activeStepNumber",
        "activeTab",
        "tab",
    ],
    emits: [
        "select",
    ],
    data() {
        return {
            steps: STEPS,
            printingTypes: PRINTING_TYPES,
            isCollapsed: false,
            contentHeight: null,
        };
    },
    mounted() {
        this.$nextTick(() => {
            const content = this.$refs.stepListContent;
            if (content) {
                this.contentHeight = content.scrollHeight + "px";
            }
        });
    },
    methods: {
        collapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        isActive(stepNumber) {
            return this.activeStepNumber === stepNumber && this.activeTab === this.tab;
        }
    },
    template: `
    <div class="step-list" :class="{ 'collapsed': isCollapsed }">
    <div @click="collapse" class="step-list-header">
        <span>{{ printingTypes[tab] }}</span>
        <img 
            src="/cdn/shop/t/98/assets/chevron-down.svg" 
            alt="chevron-down" 
            :class="{ 'rotated': isCollapsed }" 
            class="chevron-icon" 
        />
    </div>
    
    <ul 
        ref="stepListContent"
        class="step-list-content"
        :style="{ maxHeight: isCollapsed ? '0px' : contentHeight }"
    >
        <template v-for="(step, index) in steps[tab]">
            <li 
                @click="$emit('select', { type: tab, stepNumber: step?.stepNumber })" 
                class="step-list-container"
                :class="{ 
                    'step-list-container-active': isActive(step?.stepNumber),
                    'step-list-container-completed': step?.isCompleted,
                }"
            >
                <div class="separate-line"></div>
                <div class="step-list-indicator">
                    <img v-if="step?.isCompleted" src="/cdn/shop/t/98/assets/check-white.svg" alt="check" />
                    <div 
                        v-else-if="isActive(step?.stepNumber)" 
                        class="white-circle">
                    </div>
                </div>
                <span class="step-list-name">
                    {{ step?.stepName }}
                </span>
            </li>
        </template>
    </ul>
</div>
    `,
};